module.exports = {"653224001":"城区街道","653224100":"洛浦镇","653224101":"山普鲁镇","653224102":"杭桂镇","653224201":"布亚乡","653224203":"恰尔巴格乡","653224205":"多鲁乡","653224206":"纳瓦乡","653224207":"拜什托格拉克乡","653224208":"阿其克乡","653224401":"良种场","653224402":"洛浦县北京农业科技示范园区","653224403":"洛浦县北京工业园区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/653224.json
// module id = 3121
// module chunks = 0